import { rolePermissionMapping } from "../../data/userAccess/userRoleMapping"

export const checkButtonDisabledStatus = (access, role, permissionDescription, buttons) => {
    if (!access || access.length === 0) {
        return true; 
    }

    if (rolePermissionMapping?.[role]) {
        const rolePermissions = rolePermissionMapping?.[role]?.permissions;
        if (rolePermissions?.includes(permissionDescription)) {
            return buttons?.[permissionDescription] ? false : true;
        }
    }

    return true;
};
